import { Text, VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LouiseQuote } from '../../../../../../../../../types/Quotes';
import FlowerBackground from '../../../../../../assets/FlowerBackground.svg';

interface Props {
  quotes: LouiseQuote[];
  riskObject: string;
}

const ComparisonMatrixFlowerBox: React.FC<Props> = ({ quotes, riskObject }) => {
  const { t } = useTranslation();

  return (
    <VStack
      align="flex-start"
      spacing="2"
      borderRadius="md"
      pt={{
        base: '10',
        desktopS: '14',
      }}
      pb={{
        base: '6',
        laptopL: '16',
      }}
      pr={{ base: '6', laptopL: '20', desktopS: '40' }}
      pl={{ base: '6', laptopL: '8' }}
      bg={`url(${FlowerBackground}) no-repeat center`}
      bgSize="cover"
      mr="6"
      mb="6"
    >
      <Text
        maxW="48"
        textStyle="h3Headline"
        color="secondary.700"
        sx={{
          '> span': {
            color: 'secondary.500',
          },
        }}
        dangerouslySetInnerHTML={{
          __html: t('You are comparing x offers', {
            amountOfOffers: quotes.length,
          }),
        }}
      />
      <Text maxW="36" textStyle="largeBodyBold" color="secondary.700">
        {t(riskObject.toUpperCase())}
      </Text>
    </VStack>
  );
};

export default ComparisonMatrixFlowerBox;
